import { render, staticRenderFns } from "./CountedServiceTransactionTabs.vue?vue&type=template&id=ec433fd0&"
import script from "./CountedServiceTransactionTabs.vue?vue&type=script&lang=js&"
export * from "./CountedServiceTransactionTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports